import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { lastValueFrom } from 'rxjs';
import { AuthService } from './auth.service';
import { LoaderService } from './loader.service';

@Injectable({ providedIn: 'root' })
export class GerarPdfGuard implements CanActivate {
  constructor(
    private afAuth: AngularFireAuth,
    private authService: AuthService,
    private router: Router,
    private loaderService: LoaderService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    this.loaderService.showLoader();
    const token = route.queryParamMap.get('token');
    const domainId = route.queryParamMap.get('domainId');

    if (!token || !domainId) {
      this.loaderService.hideLoader();
      this.authService.redirect('--gerar-pdf: missing params');
      return false;
    }

    try {
      const result: any = await lastValueFrom(this.authService.validateToken(token));
      if (!result?.token) {
        this.loaderService.hideLoader();
        this.authService.redirect('--gerar-pdf: invalid token');
        return false;
      }

      const credential = await this.afAuth.signInWithCustomToken(result.token);
      if (!credential?.user) {
        this.loaderService.hideLoader();
        this.authService.redirect('--gerar-pdf: sign in failed');
        return false;
      }

      this.authService.userId = credential.user.uid;
      this.authService.dominioId = domainId;
      this.loaderService.hideLoader();
      this.router.navigate([`/gerar-pdf/${credential.user.uid}`]);
      return false;
    } catch (err) {
      this.loaderService.hideLoader();
      this.authService.redirect(`--gerar-pdf: error ${err}`);
      return false;
    }
  }
}
